export default "__VITE_ASSET__DqnIj3yU__"